import { c as _c } from "react/compiler-runtime";
import type { Entry } from "contentful";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@/components/ui/table";
import { SpecsFieldLabels } from "@/constants/SpecsFieldLabels";
import { cn } from "@/lib/utils";
import type { TypeMaterialSkeleton } from "@/types/contentful/generated";
type MaterialEntry = Entry<TypeMaterialSkeleton, undefined, string>;
interface Props {
  material: MaterialEntry;
}
type SpecKey = keyof typeof SpecsFieldLabels;
export const SpecsTable = t0 => {
  const $ = _c(17);
  const {
    material
  } = t0;
  const fields = material.fields as Record<string, string | undefined>;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = Object.keys(SpecsFieldLabels);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const specKeys = t1 as SpecKey[];
  let t2;
  if ($[1] !== fields) {
    t2 = specKeys.filter(key => fields[key] != null && fields[key] !== "");
    $[1] = fields;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== fields || $[4] !== t2) {
    t3 = t2.map(key_0 => [key_0, fields[key_0] as string] as const);
    $[3] = fields;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const entries = t3;
  if (entries.length === 0) {
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <p className="text-muted-foreground">No material specifications available.</p>;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  const midpoint = Math.ceil(entries.length / 2);
  let rows;
  if ($[7] !== entries || $[8] !== midpoint) {
    rows = [];
    for (let i = 0; i < midpoint; i++) {
      const left = entries[i];
      const right = entries[midpoint + i];
      rows.push([left[0], left[1], right?.[0], right?.[1]]);
    }
    $[7] = entries;
    $[8] = midpoint;
    $[9] = rows;
  } else {
    rows = $[9];
  }
  const stripe = _temp;
  let t4;
  if ($[10] !== rows) {
    t4 = <Table className="hidden lg:table"><TableBody>{rows.map((t5, i_0) => {
          const [lKey, lVal, rKey, rVal] = t5;
          return <TableRow key={lKey} className={cn("border-0", stripe(i_0))}><TableHead scope="row" className={cn("p-4 text-base font-semibold leading-none text-foreground align-middle whitespace-normal", "w-1/4")}>{SpecsFieldLabels[lKey]}</TableHead><TableCell className={cn("p-4 py-4 text-base font-normal leading-none text-accent-foreground align-middle", "w-1/4")}>{lVal}</TableCell><TableCell aria-hidden={true} className="w-0 p-3 bg-background" />{rKey ? <><TableHead scope="row" className={cn("p-4 text-base font-semibold leading-none text-foreground align-middle whitespace-normal", "w-1/4")}>{SpecsFieldLabels[rKey]}</TableHead><TableCell className={cn("p-4 py-4 text-base font-normal leading-none text-accent-foreground align-middle", "w-1/4")}>{rVal}</TableCell></> : <><TableCell className="p-0 hidden" /><TableCell className="p-0 hidden" /></>}</TableRow>;
        })}</TableBody></Table>;
    $[10] = rows;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== entries) {
    t5 = <Table className="lg:hidden"><TableBody>{entries.map((t6, i_1) => {
          const [key_1, val] = t6;
          return <TableRow key={key_1} className={cn("border-0", stripe(i_1))}><TableHead scope="row" className={cn("p-4 text-base font-semibold leading-none text-foreground align-middle whitespace-normal", "w-1/2")}>{SpecsFieldLabels[key_1]}</TableHead><TableCell className="p-4 py-4 text-base font-normal leading-none text-accent-foreground align-middle">{val}</TableCell></TableRow>;
        })}</TableBody></Table>;
    $[12] = entries;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t4 || $[15] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
function _temp(idx) {
  return idx % 2 === 0 ? "bg-muted" : "bg-background";
}